import { render, staticRenderFns } from "./PhoneDetails.vue?vue&type=template&id=426b2c1d&scoped=true&"
import script from "./PhoneDetails.vue?vue&type=script&lang=js&"
export * from "./PhoneDetails.vue?vue&type=script&lang=js&"
import style0 from "./PhoneDetails.vue?vue&type=style&index=0&id=426b2c1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b2c1d",
  null
  
)

export default component.exports